import { render, staticRenderFns } from "./LayoutPaper.vue?vue&type=template&id=6aeffd34&"
import script from "./LayoutPaper.vue?vue&type=script&lang=js&"
export * from "./LayoutPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports